import React, { useState } from "react";
import { Modal, ModalBody, ModalHeader, Row, Col, CardBody } from "reactstrap";

export default function DetailsModal({
  isOpen,
  toggle,
  title,
  image,
  highQualityImage,
  sections = [],
}) {
  const [fullImageOpen, setFullImageOpen] = useState(false);

  const openFullImage = () => {
    setFullImageOpen(true);
  };

  const closeFullImage = () => {
    setFullImageOpen(false);
  };

  // Use high quality image if provided, otherwise fall back to regular image
  const fullSizeImage = highQualityImage || image;

  return (
    <>
      <Modal isOpen={isOpen} toggle={toggle} centered fullscreen>
        <ModalHeader toggle={toggle}>{title}</ModalHeader>
        <ModalBody>
          <Row className="align-items-center">
            {image && (
              <Col md={5} className="mb-3 mb-md-0">
                <div
                  className="position-relative cursor-pointer"
                  onClick={openFullImage}
                  style={{ cursor: "pointer" }}
                >
                  <img
                    src={image}
                    className="img-fluid w-100 object-fit-cover"
                    alt={title}
                  />
                  <div className="position-absolute top-0 end-0 m-2">
                    <i
                      className="uil uil-expand-arrows-alt text-white bg-dark bg-opacity-50 rounded p-1"
                      style={{ fontSize: "1.2rem" }}
                    ></i>
                  </div>
                </div>
              </Col>
            )}
            <Col md={image ? 7 : 12}>
              <CardBody className="content p-0">
                {sections.map((section, idx) => (
                  <div className="mb-3" key={idx}>
                    <h5 className="mb-2 text-numantra-primary">
                      {section.heading}
                    </h5>
                    {Array.isArray(section.content) ? (
                      <ul>
                        {section.content.map((item, i) => (
                          <li key={i}>{item}</li>
                        ))}
                      </ul>
                    ) : (
                      <p className="text-muted mb-0">{section.content}</p>
                    )}
                  </div>
                ))}
              </CardBody>
            </Col>
          </Row>
        </ModalBody>
      </Modal>

      {/* Full Size Image Modal */}
      <Modal isOpen={fullImageOpen} toggle={closeFullImage} size="xl">
        <ModalHeader toggle={closeFullImage}>{title} - Full Image</ModalHeader>
        <ModalBody className="text-center p-0">
          <img
            src={fullSizeImage}
            className="img-fluid w-100"
            alt={title}
            // style={{ maxHeight: "80vh", objectFit: "contain" }}
          />
        </ModalBody>
      </Modal>
    </>
  );
}
